/**
 * Build superset segments from a sequential exercise list.
 *
 * Consecutive items that share the same non-empty `superset_id` are grouped
 * together into one segment. Singletons or items with empty/null `superset_id`
 * become single-item segments (rendered as standalone exercises).
 *
 * Note: ordering matters. Two non-adjacent exercises with the same
 * superset_id will end up in separate segments — this matches how supersets
 * are actually performed (back-to-back in execution order).
 */
export function buildSupersetSegments(exercises) {
  const segments = [];
  let current = null;
  (exercises || []).forEach((ex, idx) => {
    const sid = (ex?.superset_id || "").trim();
    if (sid && current && current.supersetId === sid) {
      current.items.push({ ex, idx });
    } else {
      current = { supersetId: sid || null, items: [{ ex, idx }] };
      segments.push(current);
    }
  });
  // A segment is a "true" superset only if it has 2+ items AND a supersetId.
  return segments.map((s) => ({
    ...s,
    isSuperset: !!s.supersetId && s.items.length >= 2,
  }));
}
